/* eslint-disable prettier/prettier */
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  isLoaded,
} from 'react-redux-firebase';
import { Icon } from 'react-icons-kit';
import { Spinner } from 'reactstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { download } from 'react-icons-kit/feather';
import { downloadMemberDetailCsv } from '../../../actions/update-claim';
import React, { useState } from 'react';
import _ from 'lodash';

const exportToCsv = (filename: string, rows: any, headers?: string[]): void => {
  if (!rows || !rows.length) {
    return;
  }
  const separator = ",";

  const keys: string[] = Object.keys(rows[0]);

  const columnHeaders: string[] = headers ? headers : keys;

  // Adding styling (e.g., making headers uppercase)
  const styledHeaders = columnHeaders.map(header => header.toUpperCase());

  const csvContent =
    "sep=,\n" +
    styledHeaders.join(separator) +
    "\n" +
    rows.map((row: { [x: string]: any; }) => {              
      const cell = row === null || row === undefined ? '' : row;
      return cell;
    }).join('\n');

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

const openLinkInNewTab = async (setLoading: (loading: boolean) => void) => {
  setLoading(true);
  const respo = await downloadMemberDetailCsv();
  const headerList = [
    "Member Name", "Address", "Country", "Currency", "Key Contact Email",
    "Key Contact", "Language", "Telephone", "Telephone_alt", "Vat",
    "Watch List EmailIds", "Website"
  ];

  if (respo !== undefined) {
    for (let i = 0; i < respo[0].length; i++) {
      respo[0][i][1] = respo[0][i][1].replace(/,/g, "");
    }
    exportToCsv("MembersList.csv", respo[0], headerList);
  }
  setLoading(false);
};

const PartnersDetails: React.FC<{ partnersData: any[] }> = ({ partnersData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div className="pricing-section">
      {/* Banner */}
      <div className="section-banner teal">
        <div>
          <div className="section-banner-title">Members Information</div>
          <div className="section-banner-subtitle">Last Reviewed January 2025</div>
        </div>
        <button
          className="section-download-btn"
          onClick={() => openLinkInNewTab(setLoading)}
          disabled={loading}
          title="Download CSV"
        >
          {loading ? <Spinner size="sm" style={{ color: '#fff' }} /> : <Icon icon={download} size={18} />}
        </button>
      </div>

      {/* Table */}
      <div className="pricing-card members-card">
        <table className="price-table members-table">
          <thead>
            <tr>
              <th>Country</th>
              <th>Member</th>
              <th>Key Contact</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Invoice Details</th>
            </tr>
          </thead>
          <tbody>
            {_.map(partnersData, (partner, key) =>
              partner.active === true ? (
                <tr key={key}>
                  <td className="members-country">{partner.country}</td>
                  <td>{partner.name}</td>
                  <td>{partner.keycontact}</td>
                  <td>{partner.telephone}</td>
                  <td>{partner.keyContactEmail}</td>
                  <td>{partner.vat}</td>
                </tr>
              ) : null
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapQueryToProps = (): ReduxFirestoreQueries => {
  return [
    {
      collection: 'partners',
      where: ['partnerInformationVisible', '==', true],
      storeAs: 'partners',
    },
  ];
};

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
  } = state;
  const users = firestore.data.users;
  const partnersData = firestore.data.partners;

  const loading = !isLoaded(partnersData);
  return {
    loading,
    users,
    auth: auth as FirebaseReducer.AuthState,
    partnersData,
  };
};

export default compose(
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps),
)(PartnersDetails);
